exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dummy-logo{border:1px dashed #8da0aa;padding:35px 25px;text-align:center;font-size:22px;color:#8da0aa;margin-bottom:15px}.invoice-title{font-size:32px;text-transform:uppercase}.invoice-title+b{font-size:18px;opacity:.7}.invoice-address{line-height:2em;font-size:14px;margin:0 0 10px}.invoice-date{font-size:18px;opacity:.5}.invoice-client{font-size:13px;text-transform:uppercase;margin:10px 0 15px;font-weight:700}.invoice-client+.reset-ul li{padding:0 0 15px}.invoice-client+.reset-ul li b{width:80px;display:inline-block;opacity:.6}.invoice-client+h5{font-size:16px;font-weight:700;margin-bottom:10px}.invoice-client+h5+address{opacity:.5;line-height:1.6em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/theme-files/elements/invoice.css
// module id = 431
// module chunks = 0